<ul>
  @for (item of visibleItems; track item) {
    <li [ngClass]="{'is-active' : item.isActive}">
      <a href="" (click)="navigateToAnchor(item, $event)">{{item.titre}}</a>
    </li>
  }
</ul>
